import { render } from "./HomeNew.vue?vue&type=template&id=617b0d70&scoped=true"
import script from "./HomeNew.vue?vue&type=script&lang=js"
export * from "./HomeNew.vue?vue&type=script&lang=js"

import "./HomeNew.vue?vue&type=style&index=0&id=617b0d70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-617b0d70"]])

export default __exports__